<ng-template [spinnerLoader]="deviceType() === undefined" [size]="'sm'"></ng-template>

<label for="producerFilter" class="form-label">Tipo di Asset</label>
<select id="producerFilter" class="form-select" [value]="value()" (change)="onSelectionChange($event)" (blur)="onBlur()" [class.is-invalid]="isInvalid()">
    <option value="" selected>Tutti i tipi</option>
    @for (item of deviceType(); track $index) {
        <option [value]="item.id">{{item.name}}</option>
    }
</select>
@for (error of errors(); track $index) {
    <div class="invalid-feedback">{{ error.message }}</div>
}